exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.StripeElement {\n  background-color: white;\n  padding: 10px 12px;\n  border-radius: .125rem;\n  border: 1px solid rgba(0,0,0,.2);\n}\n.StripeElement--focus {\n  border-color: #f3103c;\n}\n.StripeElement--invalid {\n  border-color: #fa755a;\n}\n.StripeElement--webkit-autofill {\n  background-color: #fefde5;\n}\n.input-group-flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n}\n.text-field-flex {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.promo-submit-btn {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  cursor: pointer;\n  border: 3px solid #137752;\n  padding: 4px 12px;\n  color: #137752;\n  font-size: .9rem;\n  font-weight: 800;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8f64a448","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/AdultReviewAndSubmit.vue
// module id = 638
// module chunks = 0